/*
 * The names the drive draws for what the server leaves unnamed (S-06 §3.2, S-01 §3.2): My drive
 * carries no name of its own — it is "My drive" to its person and "Anna's drive" to anybody an
 * administrator's rescue let in — and Team none until somebody renames it. Every surface that names a
 * space — the sidebar, a card, a breadcrumb's first step, the quick switcher, a toast — asks here, so
 * the words are the catalogue's and chosen once. Where the server itself must name such a drive in
 * text it builds — a search hit's place, the label of a reference to a drive's top — it sends the same
 * keys as a worded name (core/i18n/worded.ts), and the catalogue words both alike.
 */

import { t } from "./i18n/t.ts"
import type { SpaceView } from "./wire/drive.gen.ts"

/** A space's name for its reader: its own, else My drive, the person's drive, or Team. */
export function spaceName(space: SpaceView): string {
	if (space.name !== undefined && space.name !== "") return space.name
	if (space.personal && space.mine) return t("drive.nav.myDrive")
	if (space.personal) return t("drive.space.personalOf", { name: space.personName ?? "" })
	return t("drive.space.team")
}
